module.exports = __webpack_public_path__ + "public/viewMessage/tripArrow.svg?ef37d420";